<div class="modal">
  <i class="fal fa-times modal__close"
     (click)="close()"></i>
  <h2 class="h2">Add New User</h2>
  <app-account-create [hideAddAnother]="data.hideAddAnother"
                      (userAdded)="emitUserAdded($event)"
                      [initialValues]="data.initialValues"></app-account-create>
</div>
